/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { I18n } from '@aws-amplify/core';
import { useWatch } from 'antd/es/form/Form';

import { SelectTask } from './SelectTask';
import { Video } from './Video';
import ButtonDefault from '@/components/ui/ButtonDefault';
import { useEvaluation } from '../../Step/components/hooks';
import { useResolution886Report } from '@/context/Resolution886Report';
import { useGetDownloadVideoURL } from '@/hooks/useGetVideoURL';

import * as S from './styles';

interface SelectOptionsProps {
	label: string;
	value: string;
}

interface TaskCardProps {
	idx: number;
	image: string;
	status: string;
	fileId: string;
	fileName: string;
	description?: string;
	activityId?: string;
	assessmentId: string;
	isLoading: boolean;
	options: SelectOptionsProps[];
	addItem: (e: React.MouseEvent<HTMLAnchorElement>) => void;
	handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	handleChange: (index: number, value: string) => void;
	goToSubStep: (param: number) => void;
}

export function TaskCard({
	idx,
	status,
	options,
	fileId,
	fileName,
	isLoading,
	activityId,
	assessmentId,
	handleInputChange,
	handleChange,
	goToSubStep,
	addItem
}: Readonly<TaskCardProps>): JSX.Element {
	const { form, report } = useResolution886Report();
	const selectedTask = useWatch(`selected_${fileId}`);
	const [videoUrl, setVideoUrl] = useState<string>('');

	const { data: videoUrlData } = useGetDownloadVideoURL({
		organization_id: report.organization?.id || '',
		company_id: report.company?.id || '',
		file_id: fileId,
		original_name: fileName
	});

	useEffect(() => {
		if (videoUrlData) {
			setVideoUrl(videoUrlData);
		}
	}, [videoUrlData]);

	useEffect(() => {
		if (!activityId) return;
		form.setFieldsValue({ [`selected_${fileId}`]: activityId });
	}, [activityId, fileId]);

	const IMG_KINEBOT_LOGO = 'https://kinebot-statics.s3.amazonaws.com/logo.png';

	const { handleEvaluation, setEvaluationName } = useEvaluation({ goToSubStep });

	return (
		<S.TaskCardContainer>
			{videoUrl ? (
				<Video url={videoUrl} fileName={fileName} frame={5} />
			) : (
				<S.ImgContainer>
					<img src={IMG_KINEBOT_LOGO} alt={fileName} />
				</S.ImgContainer>
			)}
			<S.ContentContainer>
				<S.StatusContent status={status}>
					<p>{setEvaluationName(status)}</p>
				</S.StatusContent>
				<S.TaskContent>
					<h4>{fileName}</h4>
					<SelectTask
						id={fileId}
						options={options}
						fieldName={`selected_${fileId}`}
						handleInputChange={handleInputChange}
						addItem={addItem}
						onChange={(e) => handleChange(idx, e)}
						loading={isLoading}
					/>
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<ButtonDefault
							type="default"
							style={{ marginLeft: 'auto', marginRight: 'auto' }}
							onClick={() => handleEvaluation(fileId, assessmentId)}
							disabled={!selectedTask}
							loading={isLoading}
						>
							{I18n.get('Evaluate')}
						</ButtonDefault>
					</div>
				</S.TaskContent>
			</S.ContentContainer>
		</S.TaskCardContainer>
	);
}
